module.exports = __webpack_public_path__ + "media/notification-3.2f38567d.mp3";